import { ChevronDownWide, ChevronUpWide } from "@gravity-ui/icons";
import {
  Alert,
  Button,
  Flex,
  Icon,
  Label,
  Spin,
  Text,
} from "@gravity-ui/uikit";
import { useAction, useAtom } from "@reatom/npm-react";
import { TraceOrderData } from "definitions/poizon-api";
import { useEffect, useMemo, useState } from "react";
import { useGravityDevice } from "src/hooks/useGravityDevice";

import { getPoizonTraceOrderWithCache } from "../../store/fetchers/getPoizonTraceOrder";
import { Stepper, StepStatsEnum } from "./components";
import css from "./TraceModal.module.scss";
interface TraceModalProps {
  clientId: string;
  orderNo: string;
  imgSrc: string;
}

export const TraceModal = ({ clientId, orderNo, imgSrc }: TraceModalProps) => {
  const getTrace = useAction(getPoizonTraceOrderWithCache);

  const [traceData] = useAtom(getPoizonTraceOrderWithCache.dataAtom);

  const [isLoading] = useAtom(getPoizonTraceOrderWithCache.isLoadingAtom);
  useEffect(() => {
    getTrace(clientId, orderNo);
  }, [getTrace, clientId, orderNo]);
  const { isMobile } = useGravityDevice();
  const [open, setOpen] = useState(true);

  if (isLoading)
    return (
      <div
        className={css.spinDiv}
        style={{ minHeight: isMobile ? "90vh" : "200px" }}
      >
        <Flex
          justifyContent="center"
          alignItems="center"
          gap="5"
          direction="column"
        >
          <Spin size="xl" />
          <Flex direction="row" wrap="wrap" gap="5">
            <div className={css.imgDiv}>
              <img src={imgSrc} />
            </div>
            <Flex direction="column" justifyContent="center" gap={1}>
              <Text variant="subheader-2">Заказ №{orderNo}</Text>
            </Flex>
            <Flex alignItems="center" gap="3"></Flex>
          </Flex>
        </Flex>
      </div>
    );
  if (!traceData || !(traceData.dispatchList?.length > 0))
    return (
      <div className={css.errorDiv}>
        <Alert
          theme="danger"
          title="Данные отсутствуют"
          message="Попробуйте позже еще раз"
        />
      </div>
    );
  return (
    <div className={css.card}>
      <Flex direction="row" wrap="wrap" gap="5">
        <div className={css.imgDiv}>
          <img src={imgSrc} />
        </div>
        <Flex direction="column" justifyContent="center" gap={1}>
          <Text variant="subheader-2">Заказ №{orderNo}</Text>
          <div>
            <Label value={traceData.dispatchList[0].number ?? "NO"}>
              Трэк-номер
            </Label>
          </div>
          <Flex direction="row" gap={3}>
            <div>
              <GetStatusButton data={traceData} />
            </div>
          </Flex>
        </Flex>
        <Flex alignItems="center" gap="3"></Flex>
      </Flex>
      <Flex direction="column" gap="5" maxWidth={900}>
        <div>
          <Button onClick={() => setOpen(!open)} size="l">
            Подробности <Icon data={open ? ChevronUpWide : ChevronDownWide} />
          </Button>
        </div>
        {open && (
          <div
            style={{
              maxHeight: "60vh",
              overflowX: "auto",
              padding: "0 10px 0 10px",
            }}
          >
            {traceData?.dispatchList.map((el, dIndex) => {
              return <OrderStage stage={el} key={dIndex} />;
            })}
          </div>
        )}
      </Flex>
    </div>
  );
};

interface OrderStageProps {
  stage: TraceOrderData["dispatchList"][number];
}

const OrderStage = ({ stage }: OrderStageProps) => {
  const steps = useMemo(
    () =>
      stage.logistics.map((log) => ({
        title: log.title,
        description: log.desc,
        time: log.time,
        status: StepStatsEnum.Completed,
      })),
    [stage],
  );

  return (
    <Flex direction="column" gap="2">
      <Text variant="subheader-2">Stage {stage.stageDesc}</Text>
      <Text>Заказан: {stage.deliverTime}</Text>
      <Text>Получен: {stage.receiverTime}</Text>
      <Stepper steps={steps} />
    </Flex>
  );
};

interface IStatusButton {
  data: TraceOrderData;
}
const GetStatusButton = ({ data }: IStatusButton) => {
  if (data.dispatchList[0].logistics[0].success)
    return (
      <Button size="l" view="flat-success" selected>
        Доставлено
      </Button>
    );
  return (
    <Button size="l" view="flat-warning" selected>
      В Пути
    </Button>
  );
};
